module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-57x57-18486c2a9e42cd6d31067ca463be3e6b.png";